import { render, staticRenderFns } from "./ResetByPhone.vue?vue&type=template&id=7ec2f3dc&scoped=true&"
import script from "./ResetByPhone.vue?vue&type=script&lang=js&"
export * from "./ResetByPhone.vue?vue&type=script&lang=js&"
import style0 from "./ResetByPhone.vue?vue&type=style&index=0&id=7ec2f3dc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec2f3dc",
  null
  
)

export default component.exports